export const OptionTariffLabel = ({ label }) => (
  <div
    className={'font-semibold py-2 pr-2.5 pl-11 flex items-center h-full rounded'}
  >
    {label}
  </div>
);
